import { setupThemeSwitch } from "./ui/ThemeSwitch";
import { setupAnalytics } from "./util/Analytics";
setupAnalytics();
setupThemeSwitch();
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register(`/serviceWorker.js?lang=${locale}&location=${location.pathname}`);
}
document.querySelectorAll(".hiddenUntilLoaded").forEach(elem => elem.classList.remove("hiddenUntilLoaded"));
